import { UI } from '@/shared/design-system/tactical-ui';
import React from 'react';
import { Trash2 } from 'lucide-react';
import { ModalWrapper } from './ModalWrapper';
import { EVENT_TYPES } from '@/shared/constants/event-types.v4';

interface DeleteLogModalProps {
    confirmDeleteLog: { eventId: string; subId?: string; type: string };
    onClose: () => void;
    onConfirm: () => void;
    isDeleting: boolean;
}

export const DeleteLogModal: React.FC<DeleteLogModalProps> = ({ 
    confirmDeleteLog, onClose, onConfirm, isDeleting 
}) => (
    <ModalWrapper onClose={onClose} borderColor="#ef4444">
        <Trash2 size={48} color="#ef4444" style={{ margin: '0 auto 20px' }} />
        <h2 style={{ ...UI.text.title, fontSize: 18, marginBottom: 10 }}>
            Delete {(confirmDeleteLog.type === EVENT_TYPES.RECOVERY || confirmDeleteLog.type === 'SLEEP') ? 'Sleep Log' : 'Activity'}?
        </h2>
        <p style={{ fontSize: '12px', color: '#666', marginBottom: '25px' }}>This action is permanent and will remove all logged data for this session.</p>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <button className="premium-btn-primary" style={{ ...UI.button.primary, backgroundColor: "#ef4444", color: "#fff", borderColor: "transparent" }} onClick={onConfirm} disabled={isDeleting}>{isDeleting ? 'DELETING...' : 'YES, DELETE PERMANENTLY'}</button>
            <button className="premium-btn-secondary" onClick={onClose}>CANCEL</button>
        </div>
    </ModalWrapper>
);
